export default __webpack_public_path__ + "static/media/gray.e01cb9f2.webp";